import Axios from "axios"
import { orderBy } from "lodash"
import { BillingSimpleModel } from "../../dashboard/models/BillingSimpleModel"
import { BillingTypedWithSourceModel } from "../../dashboard/models/BillingTypedWithSourceModel"
import { SellerBalanceModel } from "../../seller/models/SellerBalanceModel"
import { SellerComissionModel } from "../../seller/models/SellerComissionModel"
import { SubscriberChurnModel } from "../../dashboard/models/SubscriberChurnModel"
import { API_ADMIN } from "../../utils/constants/Api"
import { IFilterListWithoutPagination } from "../../utils/interfaces/FilterListInterface"

export default {
    getBillingSimpleList(filter: IFilterListWithoutPagination):Promise<BillingSimpleModel[]> {
        return Axios.get(`${API_ADMIN}reports/billings/graphic_by_month${filter.toQueryString()}`)
            .then(({data}) => {
                return (data || []).map((b:BillingSimpleModel) => new BillingSimpleModel(b))             
            })
    },
    getBillingTypedList(filter: IFilterListWithoutPagination):Promise<BillingTypedWithSourceModel[]> {
        return Axios.get(`${API_ADMIN}reports/billings/graphic_by_month_type_billing_type_source${filter.toQueryString()}`)
            .then(({data}) => {
                return (data || []).map((b:BillingTypedWithSourceModel) => new BillingTypedWithSourceModel(b))             
            })
    },
    getSubscribersChurn(filter: IFilterListWithoutPagination):Promise<SubscriberChurnModel[]> {
        return Axios.get(`${API_ADMIN}reports/subscribers/graphic_churn${filter.toQueryString()}`)
            .then(({data}) => {
                return (data || []).map((s:SubscriberChurnModel) => new SubscriberChurnModel(s))             
            })
    },
    getSellerBalanceList(filter:IFilterListWithoutPagination):Promise<SellerBalanceModel[]> {
        return Axios.get(`${API_ADMIN}reports/account_statements/balance${filter.toQueryString()}`)
            .then(({data}) => {
                return orderBy((data || []).map((sb: SellerBalanceModel) => new SellerBalanceModel(sb)), ['balance'], ['desc'])
            })
    },
    getSellerEmployeeComissionList(filter:IFilterListWithoutPagination):Promise<SellerComissionModel[]> {
        return Axios.get(`${API_ADMIN}reports/sellers/employee_comissions${filter.toQueryString()}`)
            .then(({data}) => {
                return (data || []).map((sc: SellerComissionModel) => new SellerComissionModel(sc))
            })
    },
}
